let isListenerAdded = false; // Ensure listener is only added once
const getPageVisibility = ({ setIsWindowVisible }) => {
    const onVisibilityChange = () => {
        const isVisible = document.visibilityState === "visible";
        setIsWindowVisible(isVisible);
    };
    // Prevent duplicate event listeners
    if (!isListenerAdded) {
        document.addEventListener("visibilitychange", onVisibilityChange);
        isListenerAdded = true;
    }
    // Set initial visibility state
    onVisibilityChange();
};
export default getPageVisibility;
